import React, { FC } from 'react'

type SelectItemContentProps = {
  name?: string;
  description?: string;
  pricingName?: string;
  bookingName?: string;
  jobTitle?: string;
  boldNameOnly?: boolean;
}

export const SelectItemContent: FC<SelectItemContentProps> = ({
  name,
  description,
  pricingName,
  bookingName,
  jobTitle,
  boldNameOnly = false
}) => {
  const shouldRenderOnlyName = description == undefined && jobTitle == undefined;
  return (
    shouldRenderOnlyName
      ? <>
        {boldNameOnly
          ? <strong className="divider">{name}</strong>
          : name ?? ''}
      </>
      : <>
        <p className="m-0">
          <strong>{name}</strong>
        </p>
        <p className="m-0 font-weight-normal">
          {description}{jobTitle}
        </p>
        <p className="m-0">
          {pricingName}
        </p>
        <p className="m-0 divider">
          {bookingName}
        </p>
      </>
  )
};
